import React, { useState, useEffect } from "react";
import Sidebar from "./components/Sidebar";
import ProductList from "./components/ProductList";
import CartSummary from "./components/CartSummary";
import LayoutDashboard from "layouts/layout-dashboard-collapse";
// import initialProducts from "./data/products"; // Import produk (sudah tidak dipakai, diganti menus)
// import initialCategories from "./data/categories"; // Import kategori (sudah tidak dipakai, diganti dari context)
// import PinterestGallery from "./data/PinterestGallery"; // Tampaknya tidak digunakan di logika utama POS
import { Helmet, HelmetProvider } from "react-helmet-async";
// import { IconHistory } from "@tabler/icons-react"; // Tampaknya tidak digunakan
import Swal from "sweetalert2";
import { useActiveMenu } from "./Products/MenuActiveContext";
import { PaymentMethodProvider } from "contexts/v1/masterData/PaymentMethodContext";
import { useCategory } from "./context/CategoryContext";
import { useCashierSession } from "./context/CasierSessionContext";
import CashierClosedOverlay from "./components/CashierClosedOverlay";
import OpenCasirPage from "./components/open-casir";
import { useCanvasHandler } from "hooks/useCanvasHandler";
import CloseCasirPage from "./components/close-casir";
import { TransactionProvider } from "./History/TransactionContext";
import { useAuth } from "hooks/useAuth";
import { clearCashierLocation } from "utils/locationUtils";

const POSPage = () => {
  const [cart, setCart] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("All");
  // const [products, setProducts] = useState([]); // Digantikan oleh 'menus' dari useActiveMenu
  const {
    allCashierSessions,
    getCurrentLocationSession,
    getCurrentLocation,
    refetchCashierSessions,
  } = useCashierSession();
  const { user } = useAuth(); // Mendapatkan data pengguna yang sedang login

  // Mendapatkan cashier session untuk location saat ini
  // const cashierSessions = getCurrentLocationSession(user?.id);

  // State baru untuk manajemen akses
  const [isLoadingChecks, setIsLoadingChecks] = useState(true);
  const [showUserMismatchDenial, setShowUserMismatchDenial] = useState(false);

  // console.log("User ID:", user?.id); // Optional chaining untuk keamanan
  // console.log("cashierSessions User ID:", cashierSessions?.user_id); // Optional chaining

  // const { categories, setCategories } = useCategory(); // Menggunakan categories dari context
  const { categories } = useCategory(); // Menggunakan categories dari context
  // const [searchQuery, setSearchQuery] = useState(""); // 🔹 State untuk search (searchQuery ini tampaknya tidak dipakai, yang dipakai 'search')
  const {
    menus,
    Pagination,
    refetchMenu,
    handleSearch, // Ini adalah fungsi, bukan string search query
    filterOptions,
    handleFilterByCategory,
  } = useActiveMenu();
  const [search, setSearch] = useState(filterOptions.search || "");

  // Di dalam useEffect POSPage, untuk memeriksa peran pengguna:
  // const privilegedRoleNames = ["superadmin"]; // Peran yang boleh bypass

  // Cek apakah user memiliki salah satu dari privilegedRoles
  // const hasPrivilegedRole = user.roles?.some((r) =>
  //   privilegedRoleNames.includes(r.name)
  // );

  // Function untuk mengecek apakah kasir benar-benar terbuka
  const isCashierActuallyOpen = () => {
    // Cek localStorage location
    const savedLocation = getCurrentLocation();
    console.log("Saved Location from localStorage:", savedLocation);

    // Jika tidak ada location di localStorage, kasir dianggap tutup
    if (!savedLocation) {
      return false;
    }

    // Dapatkan session untuk location saat ini
    const locationSession = getCurrentLocationSession(user?.id);
    console.log("Location Session:", locationSession);

    // Jika tidak ada session untuk location ini atau status close, kasir tutup
    if (!locationSession || locationSession.status === "close") {
      return false;
    }

    return true;
  };

  // 🔽 Logika untuk memeriksa akses pengguna dan menampilkan alert 🔽
  useEffect(() => {
    // Tunggu sampai data user dan allCashierSessions selesai dimuat (bukan undefined)
    if (
      typeof user === "undefined" ||
      typeof allCashierSessions === "undefined"
    ) {
      setIsLoadingChecks(true); // Masih memuat
      return;
    }
    setIsLoadingChecks(false); // Selesai memuat, lanjutkan pemeriksaan

    let mismatchDetected = false;

    // Dapatkan session untuk location saat ini
    const locationSession = getCurrentLocationSession(user?.id);

    // Hanya periksa ketidakcocokan jika sesi kasir ada, statusnya BUKAN "close",
    // dan locationSession.user_id juga ada (menandakan kasir dibuka oleh user tertentu)
    if (
      locationSession &&
      locationSession.status !== "close" &&
      typeof locationSession.user_id !== "undefined"
    ) {
      if (!user || !user.id) {
        // Kasus: Kasir dibuka oleh user tertentu, tapi tidak ada user yang login saat ini
        mismatchDetected = true;
        Swal.fire({
          icon: "error",
          title: "Login Diperlukan",
          text: `Kasir di lokasi ${locationSession.location} sedang digunakan oleh pengguna dengan Nama: ${locationSession.cashier.name}. Anda harus login dengan akun yang sesuai untuk mengakses.`,
          confirmButtonText: "OK",
        });
        // } else if (user.id !== locationSession.user_id) {
        //   // MODIFIKASI DI SINI: Periksa apakah pengguna adalah superadmin
        //   if (hasPrivilegedRole) {
        //     mismatchDetected = false;
        //     console.log(
        //       `Pengguna dengan peran istimewa (ID: ${user.id}) mengakses sesi kasir milik user ID: ${locationSession.user_id}`
        //     );
        //   } else {
        //     // Jika bukan superadmin dan ID tidak cocok, maka ini adalah mismatch
        //     mismatchDetected = true;
        //     Swal.fire({
        //       icon: "error",
        //       title: "Akses Ditolak",
        //       text: `Kasir di lokasi ${locationSession.location} telah dibuka oleh pengguna lain (Kasir: ${locationSession.cashier.name})`,
        //       confirmButtonText: "OK",
        //     });
        //   }
      }
    }
    setShowUserMismatchDenial(mismatchDetected);
  }, [user, allCashierSessions, getCurrentLocationSession]); // Jalankan efek ini setiap kali user atau allCashierSessions berubah

  const {
    // handleSuccess, // Tampaknya tidak digunakan secara langsung di sini
    handleError,
    showCanvasHandler,
    handleSuccessToast,
    handleLoadingThenSuccessToast,
  } = useCanvasHandler();

  const handleAddToCart = (product) => {
    if (product.total_stock <= 0) {
      Swal.fire({
        icon: "error",
        title: "Stok Habis",
        text: `"${product.name}" tidak bisa ditambahkan karena stok habis.`,
        timer: 2500,
        showConfirmButton: false,
        toast: true,
        position: "top-end",
      });
      return;
    }

    setCart((prevCart) => {
      const existingItem = prevCart.find((item) => item.id === product.id);
      if (existingItem && existingItem.quantity >= product.total_stock) {
        Swal.fire({
          icon: "warning",
          title: "Stok Tidak Cukup",
          text: `Jumlah melebihi stok tersedia untuk "${product.name}"`,
          timer: 2500,
          showConfirmButton: false,
          toast: true,
          position: "top-end",
        });
        return prevCart;
      }

      if (existingItem) {
        return prevCart.map((item) =>
          item.id === product.id
            ? { ...item, quantity: item.quantity + 1 }
            : item
        );
      }
      return [...prevCart, { ...product, quantity: 1 }];
    });
  };

  // const [saldoAwal, setSaldoAwal] = useState(null); // State ini tampaknya tidak digunakan di scope ini

  const handleOpenCasir = (e) => {
    e.preventDefault();
    showCanvasHandler(
      "OpenCasirPage",
      <OpenCasirPage
        onSuccess={() => {
          handleSuccessToast(true, "OpenCasirPage success");
          refetchCashierSessions();
        }}
        onError={handleError}
      />
    );
  };

  const handleCloseCasir = (e) => {
    const locationSession = getCurrentLocationSession(user?.id);
    if (locationSession?.status === "close" || !locationSession) {
      // Periksa juga jika locationSession null
      Swal.fire("Error", "Kasir di lokasi ini belum dibuka!", "error");
      return;
    }
    e.preventDefault();
    showCanvasHandler(
      "Close Casir ",
      <TransactionProvider>
        <CloseCasirPage
          cashierSessions={locationSession}
          onSuccess={() => {
            handleSuccessToast(true, "Close Casir success");
            // Hapus location dari localStorage saat kasir ditutup menggunakan locationUtils
            clearCashierLocation();
            refetchCashierSessions();
          }}
          onError={handleError}
        />
      </TransactionProvider>
    );
  };

  // 🔽 Render Kondisional Utama 🔽

  // 1. Tampilkan loading jika pemeriksaan awal belum selesai
  if (isLoadingChecks) {
    return (
      <LayoutDashboard>
        <div className="d-flex justify-content-center align-items-center vh-100">
          <p>Memeriksa status kasir dan pengguna...</p>
        </div>
      </LayoutDashboard>
    );
  }

  // 2. Jika terdeteksi ketidakcocokan pengguna untuk kasir yang sedang BUKA dan ada location di localStorage
  if (
    showUserMismatchDenial &&
    getCurrentLocationSession(user?.id) &&
    getCurrentLocationSession(user?.id).status !== "close" &&
    getCurrentLocation() // Pastikan ada location di localStorage
  ) {
    const locationSession = getCurrentLocationSession(user?.id);
    return (
      <HelmetProvider>
        <LayoutDashboard>
          <Helmet>
            <title>Akses Ditolak - POS System</title>
          </Helmet>
          <div className="d-flex justify-content-center align-items-center vh-100">
            <div className="text-center p-4">
              <h2>🚫 Akses Ditolak</h2>
              <p>
                Kasir di lokasi {locationSession?.location} sedang digunakan
                oleh pengguna lain. Anda tidak dapat mengakses halaman ini.
              </p>
            </div>
          </div>
        </LayoutDashboard>
      </HelmetProvider>
    );
  }

  // 3. Jika kasir TUTUP atau belum ada sesi kasir (cashierSessions null) atau tidak ada location di localStorage
  //    Tampilkan overlay untuk membuka kasir.
  if (!isCashierActuallyOpen()) {
    return (
      <HelmetProvider>
        <LayoutDashboard>
          <PaymentMethodProvider>
            {" "}
            {/* Pastikan provider tetap ada jika overlay memerlukannya */}
            <Helmet>
              <title>Kasir Tutup - POS System</title>
              <meta name="viewport" content="width=1300,initial-scale=1" />
            </Helmet>
            <CashierClosedOverlay onOpenCashier={handleOpenCasir} />
          </PaymentMethodProvider>
        </LayoutDashboard>
      </HelmetProvider>
    );
  }

  // 4. Jika semua kondisi di atas tidak terpenuhi, berarti akses diizinkan:
  //    Kasir BUKA dan ID pengguna COCOK (atau kasir tidak terikat user_id tertentu).
  return (
    <HelmetProvider>
      <LayoutDashboard>
        <PaymentMethodProvider>
          <Helmet>
            <title>POS System</title>
            <meta name="viewport" content="width=1300,initial-scale=1" />
          </Helmet>
          {/* Karena sudah ada pengecekan di atas, blok ini hanya akan render 
            jika kasir BUKA dan pengguna memiliki akses.
          */}
          <div className="d-flex vh-100">
            <Sidebar
              categories={categories}
              selectedCategory={selectedCategory}
              onSelectCategory={(categoryName) => {
                const selected = categories.find(
                  (c) => c.name === categoryName
                );
                setSelectedCategory(categoryName);
                handleFilterByCategory(selected?.id || "");
              }}
              handleFilterByCategory={handleFilterByCategory}
              setSelectedCategory={setSelectedCategory}
            />

            <div
              className="flex-grow-1 p-3 d-flex flex-column"
              style={{ marginLeft: "60px" }}
            >
              <input
                type="text"
                placeholder="Cari produk..."
                className="form-control mb-3"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                // `onKeyDown` di sini memanggil `handleSearch` dari `useActiveMenu`
                // pastikan `handleSearch` tersebut memang mengharapkan event keydown
                // atau jika itu untuk memicu search, mungkin lebih cocok `onBlur` atau tombol search.
                // Jika `handleSearch` adalah fungsi yang memfilter berdasarkan nilai `search`,
                // maka pemanggilan `handleSearch(e)` atau `handleSearch(e.target.value)` mungkin lebih tepat
                // tergantung implementasi `handleSearch`.
                // Untuk saat ini, saya biarkan `onKeyDown={handleSearch}` sesuai kode asli.
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleSearch(e);
                }} // Contoh: trigger search on Enter
                // disabled sudah tidak perlu karena halaman ini hanya muncul jika kasir buka & akses valid
              />
              {/* Tombol Close Casir hanya muncul jika kasir sedang buka */}
              <div className="mb-3 d-flex gap-2">
                <button onClick={handleCloseCasir} className="btn btn-danger">
                  Close Casir
                </button>
              </div>

              <div style={{ flexGrow: 1, overflowY: "auto" }}>
                {menus.length === 0 ? (
                  <div className="text-center">
                    <h4>Tidak ada produk tersedia</h4>
                    <p>Silakan tambahkan produk ke menu.</p>
                  </div>
                ) : (
                  <ProductList
                    categories={categories}
                    menus={menus}
                    onAddToCart={handleAddToCart}
                  />
                )}
                <div className="d-flex justify-content-center mt-3">
                  {Pagination}
                </div>
              </div>
            </div>
            {/* CartSummary juga hanya muncul jika kasir buka & akses valid */}
            <CartSummary
              cartItems={cart}
              setCart={setCart}
              onSuccess={() => {
                handleLoadingThenSuccessToast(true, "Transaksi berhasil");
                setCart([]);
                refetchMenu(); // Muat ulang data menu setelah transaksi
              }}
            />
          </div>
        </PaymentMethodProvider>
      </LayoutDashboard>
    </HelmetProvider>
  );
};

export default POSPage;
